import * as React from "react";

function Skeleton({ className, style, ...props }) {
  return (
    <div
      className="animate-pulse"
      style={{
        borderRadius: '0.375rem',
        backgroundColor: '#f1f5f9',
        ...style,
      }}
      {...props}
    />
  );
}

export { Skeleton };
